import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Warning, XCircle, ArrowRight } from "@phosphor-icons/react";

const LOW_THRESHOLD = 20; // one full build

export default function CreditAlert() {
  const { user } = useAuth();
  const navigate = useNavigate();
  if (!user || user.unlimited) return null;
  const total = (user.credits || 0) + (user.topup_credits || 0);
  if (total >= LOW_THRESHOLD) return null;

  const out = total <= 0;
  return (
    <div
      data-testid="credit-alert"
      className={`relative z-10 flex items-center justify-between gap-4 px-4 py-2.5 border-b ${
        out ? "bg-red-500/10 border-red-500/30" : "bg-forge-primary/10 border-forge-primary/30"
      }`}
    >
      <div className="flex items-center gap-2 text-sm">
        {out ? (
          <XCircle size={18} weight="fill" className="text-red-400 shrink-0" />
        ) : (
          <Warning size={18} weight="fill" className="text-forge-primary shrink-0" />
        )}
        <span className={out ? "text-red-300" : "text-yellow-200"}>
          {out
            ? "You're out of credits — buy a top-up or upgrade to keep building."
            : `Running low: ${total} credit${total === 1 ? "" : "s"} left. A full build costs 20.`}
        </span>
      </div>
      <button
        data-testid="credit-alert-cta"
        onClick={() => navigate("/billing")}
        className={`shrink-0 flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-sm transition-colors ${
          out ? "bg-red-500 text-white hover:bg-red-400" : "bg-forge-primary text-black hover:bg-yellow-400"
        }`}
      >
        {out ? "Get credits" : "Top up"} <ArrowRight size={13} weight="bold" />
      </button>
    </div>
  );
}
